const User = {
  namespaced: true,
  state: {
    avatar: null,
    User: null,
    startPage: null,
    users: [],
    itemModel: {
      name: '',
      company_name: '',
      country_id: null,
      language_id: null,
      plan_currency_id: null,
      plan_id: null,
      email: '',
      password: '',
      password_confirmation: '',
      operating_area_id: null,
      is_external: false,
      profile_id: null,
      account_id: null,
      accept_terms_use: false,
      accept_privacy_policy: false,
      token: '',
      permissions: {}
    },
    hasUsers: [],
    newUserRegister: {
      name: '',
      company_name: '',
      country_id: null,
      language_id: 1,
      plan_currency_id: 1,
      plan_id: null,
      email: '',
      password: '',
      password_confirmation: '',
      operating_area_id: 5,
      is_external: false,
      profile_id: null,
      account_id: null,
      accept_terms_use: false,
      accept_privacy_policy: false,
      token: '',
      permissions: {},
      referral_status: false,
      referral: ''
    },
    userLocate: null
  },
  getters: {
    hasAccounts: (state) => {
      if (
        state.User &&
        state.User.has_accounts &&
        state.User.has_accounts.length
      ) {
        return state.User.has_accounts
      }

      return [];
    },
    currentAccount: (state) => {
      if (
        state.User &&
        state.User.has_accounts &&
        state.User.has_accounts.length
      ) {
        return state.User.has_accounts.find(account => {
          return account.account_id === state.User.actived_account.id
        })
      }

      return null
    },
    hasAccount: (state) => {
      if (
        state.User &&
        state.User.has_accounts &&
        state.User.has_accounts.length
      ) {
        return state.User.has_accounts.find(account => {
          return account.account_id === state.User.actived_account.id
        })
      }

      return null
    },
    urlAccountCode: (state, getters) => {
      if (getters.hasAccount && getters.hasAccount.account.url_code) {
        return getters.hasAccount.account.url_code
      }

      return false
    },
    isExternal: (state, getters) => {
      if (getters.hasAccount && getters.hasAccount.is_external) {
        return getters.hasAccount.is_external
      }

      return false
    },
    profileType: (state) => {
      if (
        state.User &&
        state.User.has_accounts &&
        state.User.has_accounts.length
      ) {
        const hasAccount = state.User.has_accounts.find(account => {
          return account.id === state.User.actived_account.id
        })

        return hasAccount.profile_type
      }

      return null
    },
    myUserMenuProcesses: (state) => {
      if (
        state.User &&
        state.User.preferences &&
        state.User.preferences.menu &&
        state.User.preferences.menu.process
      ) {
        return state.User.preferences.menu.process.filter(process => {
          return process.value === true
        })
      }

      return []
    },
    myUserMenuProfiles: (state) => {
      if (
        state.User &&
        state.User.preferences &&
        state.User.preferences.menu &&
        state.User.preferences.menu.profile
      ) {
        return state.User.preferences.menu.profile.filter(profile => {
          return profile.value === true
        })
      }

      return []
    },
    myUserDashboardProcess: (state) => {
      if (
        state.User &&
        state.User.preferences &&
        state.User.preferences.dashboard &&
        state.User.preferences.dashboard.process
      ) {
        return state.User.preferences.dashboard.process.filter(process => {
          return process.value === true
        })
      }

      return []
    },
    myPermissions: (state) => {
      if (state.User && state.User.permissions) return state.User.permissions

      return null
    },
    allPermissions: (state) => {
      if (state.User && state.User.permissions &&  state.User.permissions.all) {
        return true
      }

      return false
    },
    permissonUsers: (state, getters) => {
      if (!getters.isExternal &&
        (
          getters.allPermissions ||
          (
            getters.myPermissions &&
            getters.myPermissions.user &&
            getters.myPermissions.user.access
          )
        )
      ) {
        return true
      }
      return false
    },
    permissonAccount: (state, getters) => {
      if (!getters.isExternal &&
        (
          getters.allPermissions ||
          (
            getters.myPermissions &&
            getters.myPermissions.account &&
            getters.myPermissions.account.access
          )
        )
      ) {
        return true
      }
      return false
    },
    permissonProduct: (state, getters) => {
      if (!getters.isExternal &&
        (
          getters.allPermissions ||
          (
            getters.myPermissions &&
            getters.myPermissions.product &&
            getters.myPermissions.product.access
          )
        )
      ) {
        return true
      }
      return false
    },
    permissonFinancial: (state, getters) => {
      if (!getters.isExternal &&
        (
          getters.allPermissions ||
          (
            getters.myPermissions &&
            getters.myPermissions.financial &&
            getters.myPermissions.financial.access
          )
        )
      ) {
        return true
      }
      return false
    },
    permissonProcessSet: (state, getters) => {
      if (!getters.isExternal &&
        (
          getters.allPermissions ||
          (
            getters.myPermissions &&
            getters.myPermissions.process_settings &&
            getters.myPermissions.process_settings.access
          )
        )
      ) {
        return true
      }
      return false
    },
    permissonProfileSet: (state, getters) => {
      if (!getters.isExternal &&
        (
          getters.allPermissions ||
          (
            getters.myPermissions &&
            getters.myPermissions.profile_settings &&
            getters.myPermissions.profile_settings.access
          )
        )
      ) {
        return true
      }
      return false
    },
    permissions: (state) => {
      return state.itemModel.permissions
    },
    totalUsers: (state) => {
      if (state.users && state.users.data && state.users.data.length) {
        return state.users.data.length
      }

      return 0
    }
  },
  mutations: {
    updateUser(state, myUser) {
      state.User = myUser;
      state.user = myUser;
    },
    updateItemModel(state, data) {
      state.itemModel = data;
    },
    updateUsers(state, data) {
      state.users = data;
    },
    updateStartPage(state, data) {
      state.startPage = data;
    },
    updateUserData(state, { name, email }) {
      state.User.name = name;
      state.User.email = email;

      state.user.name = name;
      state.user.email = email;
    },
    updateMyAvatar(state, image) {
      state.User.avatar = image;
      state.user.avatar = image;
    },
    setHasUsers(state, hasUsers) {
      state.hasUsers = hasUsers;
    },
    setHasUser(state, hasUser) {
      state.hasUsers.unshift(hasUser);
    },
    clearHasUser(state) {
      state.hasUsers = [];
    },
    deleteHasUser(state, id) {
      let hasUsers = state.hasUsers.filter((hasUser) => {
        return hasUser.id !== id;
      });

      state.hasUsers = hasUsers;
    },
    setNewUserRegister(state, data) {
      state.setNewUserRegister = data;
    },
    setUserLocate(state, data) {
      state.userLocate = data;
    }
  },
  actions: {
    loginUser({ dispatch }, data) {
      return new Promise((resolve, reject) => {
        if (!data.update_password) {
          dispatch('loginUserOauth', data)
            .then((startPage) => {
              resolve(startPage);
            })
            .catch(errors => {
              reject(errors);
            });

        } else {
          dispatch('setPasswordNewUser', data)
          .then((startPage) => {
            resolve(startPage);
          })
          .catch(errors => {
            reject(errors);
          });

        }
      });
    },
    setPasswordNewUser({ dispatch }, data) {
      return new Promise((resolve, reject) => {
        window.$axios.post('api/user/new/passoword/set', data)
          .then(() => {
              dispatch('loginUserOauth', data)
                .then((startPage) => {
                  resolve(startPage);
                })
                .catch(errors => {
                  reject(errors);
                });
          })
          .catch(errors => {
            reject(errors);
          });

      });
    },
    loginUserOauth(context, data) {
      return new Promise((resolve, reject) => {
        window.$axios
          .post('oauth/token', data)
          .then(response => {
            localStorage.setItem("accessData", JSON.stringify(response.data));
            window.window.$axios.defaults.headers.common["Authorization"] = "Bearer " + response.data.access_token;
            context.dispatch('getUserData')
              .then((startPage) => {
                resolve(startPage);
              })
              .catch(errors => {
                reject(errors);
              });
          })
          .catch(errors => {
            reject(errors);
          });
      });
    },
    getUserData(context, force = false) {
      return new Promise((resolve, reject) => {
        if (!localStorage.user || force) {
          window.$axios
            .get('api/system/myuser')
            .then(response => {
              if (response.data.status === 443) {
                reject(response.data);
              }

              localStorage.setItem("user", JSON.stringify(response.data));
              context.commit('updateUser', response.data);

              context.dispatch('getStartPage')
                .then(startPage => {
                  context.commit('updateStartPage', startPage);
                  resolve(startPage);
                });
            })
            .catch(error => {
              reject(error);
            });
        } else {
          context.commit('updateUser', JSON.parse(localStorage.user));
          context.dispatch('getStartPage')
            .then(startPage => {
              context.commit('updateStartPage', startPage);
              resolve(startPage);
            });
        }
      });
    },
    getUserLocate({ commit }) {
      return new Promise((resolve, reject) => {
        // By https://ipinfo.io
        let config = {
          headers: {
            Authorization: 'Bearer  fec8e11e9a11cd'
          }
        }

        window.$axios.get('https://ipinfo.io', config)
          .then(response => {
            commit('setUserLocate', response);
            resolve(response);
          })
          .catch((error) => {
            this.isLoading = false;
            reject(error.data);
          });
      });
    }
  }
}

export default User
